const state = {
	meta: [],
	openGraphImage: null,
};

const mutations = {
	setMetaData(state, payload) {
		state.meta = payload;
	},
	getOpenGraphImage(state, payload) {
		state.openGraphImage = payload;
	},
};

const actions = {};

const getters = {
	metaData: (state) => {
		return state.meta;
	},
	metaShareImage: (state) => {
		return state.openGraphImage;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
